import axios from "axios";
import { apiConstants } from "./Constant/constants";
import CryptoJS from "crypto-js";
// export const apiUrl = "https://cms-efiexchange.blockstall.com/api/v1/"; // Production Mode
export const apiUrl = "https://proex-signup-cms.rare-able.com/api/v1/"; // qa url
export const apiUrlV2 = "https://proex-signup-cms.rare-able.com//api/v2/"; // qa url
// export const apiUrl = "https://cms-proexchange.rare-able.com/api/v1/"; // staging URL

// export const apiUrl = "http://localhost:8000/api/v1/"; // qa url
// export const apiUrlV2 = "https://localhost:8000/api/v2/"; // qa url

const signContent = (url, body, apiKey) => {
  let stringifiedObj = {};

  for (const key in body) {
    if (((url !== "business_onboarding") || (url == "business_onboarding" && localStorage.getItem("user_service_type") == "sp"))) {
      if (Object.hasOwnProperty.call(body, key) && !('File' in window && body[key] instanceof File)) {
        if (body[key] && typeof body[key] === 'object' && !(body[key] instanceof File)) {
          stringifiedObj[key] = String(JSON.stringify(body[key]));
        } else {
          stringifiedObj[key] = String(body[key]).trim();
        }
      }
    }
    else {
      const transformFieldData = (fieldData) => {
        const transformed = {
          mobile: fieldData.mobile.trim(),
          country_code: fieldData.country_code.trim(),
          gender: fieldData.gender.trim(),
          dob: fieldData.dob.trim(),
          business_persons: [],
          company_name: fieldData.company_name.trim(),
          preferred_name: fieldData.preferred_name.trim(),
          registration_number: fieldData.registration_number.trim(),
          registration_date: fieldData.registration_date.trim(),
          sector: fieldData.sector.trim(),
          billing_address_1: fieldData.billing_address_1.trim(),
          billing_address_2: fieldData.billing_address_2.trim(),
          billing_country: fieldData.billing_country.trim(),
          billing_state: fieldData.billing_state.trim(),
          billing_city: fieldData.billing_city.trim(),
          billing_postal_code: fieldData.billing_postal_code.trim(),
          delivery_address_1: fieldData.delivery_address_1.trim(),
          delivery_address_2: fieldData.delivery_address_2.trim(),
          delivery_country: fieldData.delivery_country.trim(),
          delivery_state: fieldData.delivery_state.trim(),
          delivery_city: fieldData.delivery_city.trim(),
          delivery_postal_code: fieldData.delivery_postal_code.trim(),
          device_type: fieldData.device_type.trim(),
          device_token: fieldData.device_token.trim(),
          language: fieldData.language.trim()
        };
      
        const businessPersons = {};
      
        Object.entries(fieldData).forEach(([key, val]) => {
          const match = key.match(/business_persons\[(\d+)\](?:\[person\](?:\[address\])?)?\[([^\]]+)\]/);
          if (match) {
            const index = match[1];
            const fieldKey = match[2];
            if (!businessPersons[index]) {
              businessPersons[index] = { person: { address: {} }, types: [], ownership: "" };
            }
      
            if (["line1", "line2", "city", "state", "country", "postalCode"].includes(fieldKey)) {
              businessPersons[index].person.address[fieldKey] = val.trim();
            } else if (fieldKey === "ownership") {
              businessPersons[index].ownership = val.trim();
            } else if (fieldKey === "types") {
              businessPersons[index].types.push(val.trim());
            } else {
              businessPersons[index].person[fieldKey] = val.trim();
            }
          }
        });
      
        transformed.business_persons = Object.values(businessPersons).map(person => {
          const { email,firstName,middleName,lastName,dob,birthCountry, ...restPerson } = person.person;
          person.person = {  email:email,firstName:firstName,middleName:middleName,lastName:lastName,dob:dob,address: person.person.address,birthCountry:birthCountry }; // types and ownership come last
          return person;
        });
      
        return transformed;
      }; 
      
      stringifiedObj = transformFieldData(body)

    }
  }

  const plainContent = `/${url.substring(url.lastIndexOf('/') + 1)}${body ? JSON.stringify(stringifiedObj) : "{}"}${sessionStorage.getItem("salt_key") || localStorage.getItem("salt_key")}`;

  return CryptoJS.HmacSHA256(plainContent, apiKey).toString(CryptoJS.enc.Hex);
}

const Environment = {
  postMethod: async (action, object, baseUrl = apiUrl) => {
    const url = baseUrl + action;

    let formData = new FormData();
    // append your data
    for (var key in object) {

      if (object[key] && typeof object[key] === 'object' && !(object[key] instanceof File)) {
        formData.append(key, JSON.stringify(object[key]));
      } else {
        formData.append(key, object[key]);
      }
    }
    formData.append("device_type", apiConstants.DEVICE_TYPE);
    formData.append("device_token", apiConstants.DEVICE_TOKEN);

    const accessToken = localStorage.getItem("token") ?
      localStorage.getItem("token")
      : sessionStorage.getItem("token") ?
        sessionStorage.getItem("token")
        : "";

    const language = localStorage.getItem("lang") ?
      localStorage.getItem("lang")
      : "en";
    formData.append("language", language);
    //signature generation
    const apiKey = (sessionStorage.getItem('api_key') || localStorage.getItem('api_key'));
    let signature = "";
    if (apiKey) {
      signature = signContent(action, { ...object, "device_type": apiConstants.DEVICE_TYPE, "device_token": apiConstants.DEVICE_TOKEN, "language": language }, apiKey);
    }
    // let config = { headers: { Authorization: 'Bearer ' + accessToken, 'X-Api-Key': ((localStorage.getItem('api_key') || sessionStorage.getItem('api_key'))) || "", 'X-Api-Signature': signature, "ngrok-skip-browser-warning": "69420", } };
    let config = { headers: { 'Access-Control-Allow-Origin': "*", Authorization: 'Bearer ' + accessToken, 'X-Api-Key': ((sessionStorage.getItem('api_key') || localStorage.getItem('api_key'))) || "", 'X-Api-Signature': signature } };

    return await axios.post(url, formData, config);
  },

  postMethodV2: async (action, object, baseUrl = apiUrlV2) => {
    const url = baseUrl + action;

    let formData = new FormData();
    // append your data
    for (var key in object) {

      if (object[key] && typeof object[key] === 'object' && !(object[key] instanceof File)) {
        formData.append(key, JSON.stringify(object[key]));
      } else {
        formData.append(key, object[key]);
      }
    }
    formData.append("device_type", apiConstants.DEVICE_TYPE);
    formData.append("device_token", apiConstants.DEVICE_TOKEN);

    const accessToken = localStorage.getItem("token") ?
      localStorage.getItem("token")
      : sessionStorage.getItem("token") ?
        sessionStorage.getItem("token")
        : "";

    const language = localStorage.getItem("lang") ?
      localStorage.getItem("lang")
      : "en";
    formData.append("language", language);
    //signature generation
    const apiKey = (sessionStorage.getItem('api_key') || localStorage.getItem('api_key'));
    let signature = "";
    if (apiKey) {
      signature = signContent(action, { ...object, "device_type": apiConstants.DEVICE_TYPE, "device_token": apiConstants.DEVICE_TOKEN, "language": language }, apiKey);
    }
    // let config = { headers: { Authorization: 'Bearer ' + accessToken, 'X-Api-Key': ((localStorage.getItem('api_key') || sessionStorage.getItem('api_key'))) || "", 'X-Api-Signature': signature, "ngrok-skip-browser-warning": "69420", } };
    let config = { headers: { Authorization: 'Bearer ' + accessToken, 'X-Api-Key': ((sessionStorage.getItem('api_key') || localStorage.getItem('api_key'))) || "", 'X-Api-Signature': signature } };

    return await axios.post(url, formData, config);
  },

  getMethod: async (action, object) => {
    let userId =
      localStorage.getItem("userId") !== "" &&
        localStorage.getItem("userId") !== null &&
        localStorage.getItem("userId") !== undefined
        ? localStorage.getItem("userId")
        : "";
    let accessToken =
      localStorage.getItem("accessToken") !== "" &&
        localStorage.getItem("accessToken") !== null &&
        localStorage.getItem("accessToken") !== undefined
        ? localStorage.getItem("accessToken")
        : "";

    const url = apiUrl + action;

    let formData = new FormData();

    // By Default Id and token

    formData.append("id", userId);
    formData.append("token", accessToken);

    // append your data
    for (var key in object) {
      formData.append(key, object[key]);
    }

    // By Default added device type and login type in future use

    formData.append("login_by", apiConstants.LOGIN_BY);
    formData.append("device_type", apiConstants.DEVICE_TYPE);
    formData.append("device_token", apiConstants.DEVICE_TOKEN);

    return await axios.get(url, formData);
  },

  getConversion: async (from, to) => {
    return await axios.get(`https://api.coingecko.com/api/v3/simple/price?ids=${from}&vs_currencies=${to}`);
  }
};

export default Environment;